<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm03">
<a id="page05">
<div class="chapterHead">
<h2 class="chapterNumber" style="text-indent: 0%;"><em class="italic">File Number 4H-289A</em></h2></div>
<div class="chapterBody">
<p class="paraNoIndent" style="text-indent:0%;">Data Collected by Dalhousie, Dr. Donna L.</p>
<p class="paraNoIndent" style="text-indent:0%;">Patient Number: 289</p>
<p class="paraNoIndent" style="text-indent:0%;">Patient Classification: Level 2 Corporal Threat (CT2)</p>
<p class="paraNoIndent" style="text-indent:0%;">Observed Abilities: Please refer to document 4H-289B.</p>
<p class="paraNoIndent" style="text-indent:0%;">Date Retrieved: 19-December-20XX</p>
<p class="paraNoIndent" style="text-indent:0%;">Retrieval Information:</p>
<p class="para" style="text-indent:5%;">Subject was located via the paranormal abilities of Patient 251, documented in file 4H-251A. Retrieval operation was conducted during daylight hours, counter to standard operating procedures, due to the supposed nature of the subject. Dr. D. Dalhousie was accompanied by five Chi-level personnel, all in possession of standard-issue Tasers and full riot gear.</p>
<p class="para" style="text-indent:5%;">Subject was located in the penthouse suite of a condominium complex in Midtown Manhattan. Upon entering the domicile, numerous objects of interest were noted, but due to time constraints the team was unable to give them appropriate attention. We discovered the subject in a back bedroom, comatose. Statements from 251 seem to have been supported due to the presence of blackout curtains. Sedative was used but proved unnecessary. Subject did not awaken when secured, and transportation to Site 4H was uneventful, including temporary stop for gas in Warrensburg, NY. Subject was classified as 289 and placed in one of the vacant rooms.</p>
<p class="para" style="text-indent:5%;">Patient 289 awoke at 16:31:15, at sundown. Upon waking, patient vocalized threats and physically attempted to tear down the door. Escape efforts continued for several hours before cessation. Around this time, one of the orderlies reported hearing whispers coming from Patient 77’s room.</p>
<p class="paraNoIndent1" style="text-indent:0%;">Experiment Log: Located in File 4H-289Ex.</p>
<p class="paraNoIndent1" style="text-indent:0%;">Dalhousie, Anecdote: <em class="italic">289 was placed in a room near Patient 77. At first, 77 expressed extreme distress at his capture. These protestations dwindled over the course of several months. Documentation regarding their relationship and subsequent measures located in file 4H-77C. Once 77 was reclassified to staff, 289 displayed signs of despondence. Due to the apparent apathy, as well as arrangements made by 77 and this administration, 289 was removed from the viable testing pool.</em></p>
</div>
</a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781426890574_fm03.vue?19d461b3